import { Category, GameListRep } from "@/api/home";
import { useRouter } from "@/i18n/routing";
import clsx from "clsx";
import { useMemo, useRef, useState } from "react";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import styles from "./style.module.scss";

interface Props {
    data: Category;
}

const HomeProvider: React.FC<Props> = ({ data }) => {
    const swiperRef = useRef<SwiperClass | null>(null);
    const [actIdx, setActIdx] = useState(0);
    const router = useRouter();

    const renderData = useMemo<GameListRep[]>(() => {
        if (!data?.game_list?.length) return [];
        const result = data.game_list.map((item: any) => {
            // const randomStr = parseInt(`${Math.random() * 1000000}`);
            // item.uid = `${item.id}-${randomStr}`;
            return item;
        });

        return [...result];
    }, [data]);

    const todoHandler = (item: GameListRep) => {
        router.push({
            pathname: `/gameList2?provider_id=${item.id}`,
        });
    };

    const changeSwiper = (type: 1 | -1) => {
        if (type === -1) {
            swiperRef.current!.slidePrev();
        }
        if (type === 1) {
            swiperRef.current!.slideNext();
        }
    };

    const slidesPerView = useMemo(() => {
        if (renderData.length > 4) return 4.5;
        return 3.5;
    }, [renderData]);
    if (!renderData?.length) return null;
    return (
        <div className={styles.container}>
            <div className="mb-[.1rem] flex items-center">
                {data.image && <img className="mr-[.1rem] w-[.3rem]" src={data.image} alt="" />}
                <div className="text-[.15rem] font-bold">{data.category_name}</div>
            </div>
            <div className={styles.privoderBox}>
                <Swiper slidesPerView={slidesPerView} spaceBetween={5}>
                    {renderData?.map((item: any, idx) => {
                        return (
                            <SwiperSlide key={item.id}>
                                <div
                                    className={clsx(
                                        "flex h-[100%] flex-col items-center justify-center",
                                        styles.manufactureritem
                                    )}
                                    onClick={() => todoHandler(item)}
                                >
                                    <img
                                        src={item.game_icon}
                                        className={styles.providerIcon}
                                        alt=""
                                    ></img>
                                    {/* <div className="mt-[.06rem] text-[.1rem]">{item.provider}</div> */}
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
            {/* <Swiper
                slidesPerView={slidesPerView}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
                // centeredSlides={true}
                loop={false} // 仅在数据量足够时启用 loop
                onSlideChange={(swiper) => {
                    setActIdx(swiper.activeIndex);
                }}
                spaceBetween={6}
                pagination={{}}
            >
                {renderData?.map((item: any, idx) => (
                    <SwiperSlide
                        key={item.id}
                        className={clsx(styles.manufactureritem)}
                        onClick={() => todoHandler(item)}
                        // style={{
                        //     width: "100px", // 确保每个项目都有相同的宽度
                        // }}
                    >
                        <div className="flex h-[100%] flex-col items-center justify-center">
                            <img src={item.game_icon} className={styles.providerIcon} alt=""></img>
                            <div className="mt-[.06rem] text-[.1rem]">{item.provider}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper> */}
            {/* <i
                className={clsx("iconfont icon-xiangyou2", styles.left)}
                onClick={() => changeSwiper(-1)}
            ></i>
            <i
                className={clsx("iconfont icon-xiangyou2", styles.right)}
                onClick={() => changeSwiper(1)}
            ></i> */}
        </div>
    );
};

export default HomeProvider;
